import PDF from './pdf'
import { formatAccounting, capitalizeFirstLetter, getCurrentDateEnUsFormat } from '../lib/utils'

export default class ExpenseReport extends PDF {
  /**
   * Description
   * @param {import('jspdf').DocumentProperties} args
   */
  constructor(args = {}) {
    super()
    this.doc.setProperties({
      unit: 'mm',
      format: 'a4',
      ...args,
    })
    this.addFonts()
  }

  /**
   * Description
   * @param {boolean} [cancel]
   */
  __header({ storeName = '', dateRange = '' }) {
    const title = `${capitalizeFirstLetter(storeName)} Report`
    this.centerText({ fontSize: 24, text: title, yOffset: 15, color: [55, 71, 79] })
    this.centerText({ fontSize: 12, text: 'Expenses', yOffset: 22, color: [55, 71, 79] })
    this.centerText({ fontSize: 12, text: dateRange, yOffset: 27 })
    this.doc.setFillColor('#CFD8DC')
    this.doc.line(15, 30, 195, 30, 'F')
  }

  /**
   * Description
   * @param {HeadingData} subHeader
   * @returns {void}
   */
  __subHeader(subHeader) {
    const { avgDailyExpense = '', totalExpenses = '' } = subHeader || {}
    const [x, y] = [15, 40]
    const delimiter = ':'

    const { labelWidth: textLength } = this.generateField({
      label: 'AVG Daily Expenses',
      value: avgDailyExpense,
      coordinates: [x, y + 5],
      delimiter,
    })

    this.generateField({
      label: 'Total Expenses',
      value: totalExpenses,
      coordinates: [x, y],
      textLength,
      delimiter,
    })
  }

  /**
   * Description
   * @param {{ totalAmount: number; }} params
   * @param {ReceiptItem} body
   * @returns {any}
   */
  __table(_, body) {
    this.doc.autoTable({
      head: [['Category', 'Desc', 'Date', 'Cost']],
      startY: 50,
      body: [
        ...body,
      ],
    })
  }

  /**
   * Description
   * @param {string} receiptNo
   * @returns {void}
   */
  __save(namePrefix) {
    const name = `${namePrefix}_expenses_${new Date().getTime()}`.replace(/[\s]+/g, '_')
    this.doc.save(name)
  }

  /**
   * Description
   * @param {HeadingData} data
   * @param {ReceiptItem[]} items
   * @returns {any}
   */
  generate(data, items) {
    this.__header(data)
    this.__subHeader(data)
    this.__table(data, items)
    this.__save(data.namePrefix)
  }
}

/**
 * @typedef HeadingData
 * @property {string} namePrefix
 * @property {string} avgDailyExpense
 * @property {string} dateRange
 * @property {string} totalExpenses
 * 
 * @typedef Items
 * @property {string} category
 * @property {string} description
 * @property {string} date
 * @property {string} cost
 */
